(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('ProductDetailController', ProductDetailController);

  /* ngInject */
  function ProductDetailController($state, $stateParams, Flash, vmsProductService, sessionService, vendorService) {
    const vm = this;

    vm.deleteProduct = deleteProduct;
    vm.id = $stateParams.id;
    vm.product = {};
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      getProduct();
      getVendor();
    }

    function deleteProduct() {
      vmsProductService(sessionService.getAuthToken()).destroy({ vendorId: vm.vendorId, id: vm.id }, _ => {
        $state.go('application.vms.vendor-detail', { id: vm.vendorId });
        Flash.create('success', 'Product successfully deleted.');
        angular.element('#deleteProductModal').modal('hide');
      },
      _ => {
        Flash.create('danger', 'An error occurred with the submission. Please try again later.');
      });
    }

    function getProduct() {
      vmsProductService(sessionService.getAuthToken()).get({ vendorId: vm.vendorId, id: vm.id }, response => vm.product = response);
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }
  }
})();
